import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantDataService } from '../services/data-access/tenant-data.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantData = inject(TenantDataService);
  const subTenant = tenantData.subTenant();
  const tenantId = tenantData.tenantId();

  let headers = req.headers;

  if (subTenant) {
    headers = headers.set('X-Subtenant', subTenant);
  }

  if (tenantId) {
    headers = headers.set('X-Tenant-ID', tenantId);
  }

  const clonedReq = req.clone({ headers });
  return next(clonedReq);
};
